import React from 'react';
import { Row, Col, Card, Typography, Progress, Tag } from 'antd';
import { useGetMyCourseStatsQuery } from '../../../features/courses/coursesApi';
import GradeScale from '../components/GradeScale';

const { Text } = Typography;

const fmtDate = (iso) => {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit' });
    } catch (e) {
        return '—';
    }
};

const labelStyle = {
    textTransform: 'uppercase' as const,
    letterSpacing: 0.6,
    fontSize: 11,
    fontWeight: 600,
    color: 'var(--wsb-muted)',
};
const cardBody = { padding: '20px 22px', height: '100%' };

const MyLearningPanel = ({ courseId }) => {
    const { data, isLoading } = useGetMyCourseStatsQuery(courseId, { skip: !courseId });

    if (!courseId) return null;
    if (isLoading || !data) {
        return <Card loading style={{ marginBottom: 4, minHeight: 150 }} />;
    }

    const { progress, grade, feedback } = data;

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 4 }}>
            <Col xs={24} md={8}>
                <Card bodyStyle={cardBody} style={{ height: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                        <Progress
                            type="circle"
                            percent={progress.percent}
                            width={94}
                            strokeColor={{ '0%': '#69b1ff', '100%': '#1890ff' }}
                            strokeWidth={9}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <Text style={labelStyle}>Postęp kursu</Text>
                            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--wsb-text)', lineHeight: 1.1 }}>
                                {progress.completed}{' '}
                                <span style={{ fontSize: 15, color: 'var(--wsb-muted)', fontWeight: 500 }}>
                                    / {progress.total} modułów
                                </span>
                            </div>
                            {progress.current_lesson_title && (
                                <Text type="secondary" style={{ fontSize: 12.5, maxWidth: 180 }}>
                                    Teraz: {progress.current_lesson_title}
                                </Text>
                            )}
                        </div>
                    </div>
                </Card>
            </Col>

            <Col xs={24} md={9}>
                <Card bodyStyle={cardBody} style={{ height: '100%' }}>
                    <Text style={labelStyle}>Twoja ocena</Text>
                    {grade ? (
                        <>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, margin: '6px 0 14px' }}>
                                <span style={{ fontSize: 36, fontWeight: 700, color: 'var(--wsb-text)', lineHeight: 1 }}>
                                    {grade.value.toFixed(1)}
                                </span>
                                <Tag color="success" style={{ borderRadius: 8 }}>
                                    Zaliczone
                                </Tag>
                                <Text type="secondary" style={{ fontSize: 12.5, marginLeft: 'auto' }}>
                                    lepszy od {grade.better_than_percent}% grupy
                                </Text>
                            </div>
                            <GradeScale grade={grade.value} classAverage={grade.class_average} />
                        </>
                    ) : (
                        <div style={{ padding: '18px 0', color: 'var(--wsb-muted)', fontSize: 14 }}>
                            Zadanie w toku — brak oceny.
                        </div>
                    )}
                </Card>
            </Col>

            <Col xs={24} md={7}>
                <Card bodyStyle={cardBody} style={{ height: '100%' }}>
                    <Text style={labelStyle}>Informacja zwrotna</Text>
                    {feedback ? (
                        <>
                            <div style={{ fontSize: 32, fontWeight: 700, color: 'var(--wsb-text)', marginTop: 6, lineHeight: 1 }}>
                                {feedback.turnaround_days}{' '}
                                <span style={{ fontSize: 15, color: 'var(--wsb-muted)', fontWeight: 500 }}>dni</span>
                            </div>
                            <Text type="secondary" style={{ fontSize: 12.5 }}>
                                czas oczekiwania na ocenę
                            </Text>
                            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 10 }}>
                                przesłano {fmtDate(feedback.submitted_at)} · oceniono {fmtDate(feedback.graded_at)}
                            </Text>
                        </>
                    ) : (
                        <div style={{ padding: '18px 0', color: 'var(--wsb-muted)', fontSize: 14 }}>
                            Brak ocenionych prac.
                        </div>
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default MyLearningPanel;
